export default __webpack_public_path__ + "static/media/oxygen-red.b34ddd54.svg";